import type { ReactNode } from "react"

import { cx } from "../lib/cx"
import styles from "./chip.module.css"

/**
 * Чип-переключатель.
 *
 * ПОЧЕМУ button С aria-pressed, А НЕ ССЫЛКА И НЕ ФЛАЖОК.
 * Чип переключает вид уже открытого экрана («показать отменённые», «шаг 15 мин»),
 * то есть это кнопка с двумя положениями. aria-pressed — единственный признак,
 * который сообщает положение, не полагаясь на цвет: иначе выбранный чип отличается
 * от невыбранного только заливкой, а в градациях серого и для дальтоника — ничем.
 *
 * Тем чипам, что меняют АДРЕС (день журнала, раздел), место не здесь, а в ссылке:
 * состояние экрана живёт в адресе (ТЗ §4).
 */
export function Chip(props: {
  readonly children: ReactNode
  readonly active?: boolean
  readonly count?: number | undefined
  /** Что означает счётчик словами: «3» в отрыве от подписи не значит ничего. */
  readonly countLabel?: string | undefined
  readonly disabled?: boolean
  readonly onClick?: (() => void) | undefined
  readonly className?: string | undefined
}): ReactNode {
  const { active = false, count, countLabel, disabled = false, onClick } = props

  return (
    <button
      type="button"
      className={cx(styles.chip, props.className)}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{props.children}</span>
      {typeof count === "number" ? (
        <span className={styles.count}>
          <span aria-hidden="true">{count}</span>
          <span className="plnr-visually-hidden">
            {countLabel === undefined ? `${count}` : `${count} ${countLabel}`}
          </span>
        </span>
      ) : null}
    </button>
  )
}

/** Ряд чипов. Отдельный компонент, потому что перенос и отступ ряда — его забота. */
export function Chips(props: {
  readonly children: ReactNode
  readonly label?: string | undefined
  readonly className?: string | undefined
}): ReactNode {
  return (
    <div className={cx(styles.chips, props.className)} role="group" aria-label={props.label}>
      {props.children}
    </div>
  )
}
